import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faGlobeAmericas,
  faViruses,
  faHome,
  faDonate,
  faInfoCircle
} from '@fortawesome/free-solid-svg-icons';
import { NavLink } from 'react-router-dom';
import '../styles/Navbar.css';

function Navbar({ title }) {
  return (
    <header>
      <nav className="navbar">
        <NavLink to="/" className="navbar__logo">
          <div className="logo__container">
            <FontAwesomeIcon icon={faGlobeAmericas} size="2x" spin />
            <h2 className="navbar__logo-text">{title}</h2>
            <FontAwesomeIcon icon={faViruses} size="2x" pull="left" />
          </div>
        </NavLink>
        <div className="navbar__links">
          {links.map((link, index) => (
            <NavLink
              activeClassName="navbar__link--selected"
              key={`${link.name}-LinkRoute-${index}`}
              className="navbar__link"
              exact
              to={link.route}>
              <div>
                <FontAwesomeIcon icon={link.icon} size="2x" />
                <h3>{link.name}</h3>
              </div>
            </NavLink>
          ))}
        </div>
      </nav>
    </header>
  );
}

const links = [
  {
    name: 'Home',
    route: '/',
    icon: faHome
  },
  {
    name: 'Donate',
    route: '/donations',
    icon: faDonate
  },
  {
    name: 'Safety',
    route: '/safety',
    icon: faInfoCircle
  }
];

export default Navbar;
